import React from "react";
import styled from 'styled-components';
import recipepic from '../pictures/recipe.jpg';

class Recipe extends React.Component {
render(){
const WORKCOVER = styled.div`
    width: 100%;
    height: 100%;
`;

const TITLE = styled.h1`
    margin: 0;
    padding-top: calc(30px + 8vw);
    padding-bottom: 3vh;
    text-align: center;
    color: black;
`;

const BOX = styled.div`
`;

const IMG = styled.img`
    width: 35%;
    height: 100%;
    display: block;
    margin: 0 auto;
    `;

const CONTENT = styled.div`
    padding: 3em;
`;

const TECH = styled.div`
    color: black;
    font-size:calc(10px + 0.4vw)
`;

const BUTTONS = styled.div`
    display: flex;
    justify-content: space-around;
    text-align:center;
    vertical-align: middle;
`;
const BUTTON = styled.a`
    width: calc(40px + 4vw);
    height: calc(20px + 2.5vw);
    line-height: calc(20px + 2.5vw);
    margin: 1em;
    padding: 0.23em 0.5em;
    font-size:calc(10px + 0.4vw)
    font-weight: bold;
    color: white;
    border-style: none;
    border-radius: 3px;
    text-decoration: none;
    background-color: #0F4137;
`;

return(
<div>
<WORKCOVER>
    <TITLE>レシピアプリ</TITLE>
    <BOX>
        <IMG src= {recipepic} alt=""/>
        <CONTENT>
            <TECH>
            使用技術：<br/>
            HTML/jQuery/JavaScript/React.js/material-UI<br/><br/>
            詳細：<br/>
            一覧から好きなレシピを選択して詳細をご覧ください。<br/>
            新規レシピを登録してレシピ一覧に追加することも可能です。複数の材料や手順を入力したい場合は、追加ボタンを押して入力欄を追加してください。<br/><br/>
            <b>写真のアップロード機能はついていないため、「画像」の欄には"curry.jpg"もしくは"korokke.jpg"を記入してください。</b>
            </TECH>
            <BUTTONS>
                <BUTTON href="https://yukiamakawa.github.io/recipe/" target="_blank">
                    デモ
                </BUTTON>
                <BUTTON href = "https://github.com/YukiAmakawa/recipe_code" target="_blank">
                    GitHub
                </BUTTON>
            </BUTTONS>
        </CONTENT>
    </BOX>
</WORKCOVER>
</div>
)}}

export default Recipe;


// WEBPACK FOOTER //
// ./src/components/Recipe.js